import { journeyAction, } from './base';

import { JourneyActionVoiceInternalDial as JourneyActionVoiceInternalDialBase, } from 'atlas-shared';

export const JourneyActionVoiceInternalDial = journeyAction({
  ...JourneyActionVoiceInternalDialBase,
  icon: 'Dial',
});
